import * as Types from '../../../_generated/types.d';

import { GeocodeResponseData } from "@googlemaps/google-maps-services-js";
import { CoachState } from "@portal/app/_common/lib/coach";
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
export type GetViewerForHostedResultQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetViewerForHostedResultQuery = { __typename?: 'Query', viewerCustomer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', isUsCitizen: boolean | null, graduatedHighSchoolIn: string | null, hasRNLicense: boolean | null, hasMilitaryAffiliation: boolean | null, dob: string | null, educationLevel: Types.EducationLevel | null, acceptedTermsVersion: Types.AcceptedTermsVersion | null, email: string | null, phone: string | null, careerGoal: Types.CareerGoal | null, careerChangeConcern: Types.CareerChangeConcern | null, careerTimeline: Types.CareerTimeline | null, careerAspectsRanking: Array<Types.CareerAspect> | null, careerAspectsDesired: string | null, jobEnjoyment: string | null, jobDislike: string | null, coachStyle: Types.CoachStyle | null, degreeLevelInterest: Array<Types.ProgramLevel> | null, furtherEducationReason: Array<Types.CoachFurtherEducationReason> | null, industryInterest: Types.VocationIndustry | null, mainFocus: Array<Types.CoachMainFocus> | null, subindustryInterest: Array<Types.VocationSubindustry> | null, timeframePreference: Types.CoachTimeframe | null, enrollLikelihood: string | null, programEnvironment: string | null, address: { __typename?: 'AddressWithZip', street: string | null, street2: string | null, city: string | null, state: string | null, zip: string } | null }, user: { __typename?: 'User', id: string, nameFirst: string | null, nameLast: string | null, email: string | null, phone: string | null, phoneVerified: boolean | null } | null } | null };

export type UpdateCustomerHostedResultMutationVariables = Types.Exact<{
  data: Types.CustomerUpdateInput;
}>;


export type UpdateCustomerHostedResultMutation = { __typename?: 'Mutation', updateViewerCustomer: { __typename?: 'Customer', id: string, user: { __typename?: 'User', id: string, nameFirst: string | null, nameLast: string | null, email: string | null, phone: string | null, phoneVerified: boolean | null } | null } | null };

export type UpdateCustomerDetailsHostedResultMutationVariables = Types.Exact<{
  data: Types.CustomerDetailsUpdateInput;
}>;


export type UpdateCustomerDetailsHostedResultMutation = { __typename?: 'Mutation', updateViewerCustomerDetails: { __typename?: 'Customer', id: string } | null };

export type CreateCustomerHostedResultMutationVariables = Types.Exact<{
  data: Types.CustomerAndEnrollmentItemCreateInput;
}>;


export type CreateCustomerHostedResultMutation = { __typename?: 'Mutation', createOneCustomer: { __typename?: 'CustomerAndEnrollmentItem', customer: { __typename?: 'Customer', id: string, user: { __typename?: 'User', id: string, email: string | null, tokens: { __typename?: 'ClientAuthToken', accessToken: string, refreshToken: string } } | null } } | null };

export type RequestPhoneCodeHostedMutationVariables = Types.Exact<{
  phone: Types.Scalars['String']['input'];
  isMobile: Types.Scalars['Boolean']['input'];
}>;


export type RequestPhoneCodeHostedMutation = { __typename?: 'Mutation', requestCodeViaPhone: boolean | null };

export type VerifyPhoneCodeHostedMutationVariables = Types.Exact<{
  phone: Types.Scalars['String']['input'];
  code: Types.Scalars['String']['input'];
}>;


export type VerifyPhoneCodeHostedMutation = { __typename?: 'Mutation', verifyPhoneCode: { __typename?: 'User', id: string, phoneVerified: boolean | null } };


export const GetViewerForHostedResultDocument = gql`
    query getViewerForHostedResult {
  viewerCustomer {
    id
    detailsMap {
      address {
        street
        street2
        city
        state
        zip
      }
      isUsCitizen
      graduatedHighSchoolIn
      hasRNLicense
      hasMilitaryAffiliation
      dob
      educationLevel
      acceptedTermsVersion
      email
      phone
      careerGoal
      careerChangeConcern
      careerTimeline
      careerAspectsRanking
      careerAspectsDesired
      jobEnjoyment
      jobDislike
      coachStyle
      degreeLevelInterest
      furtherEducationReason
      industryInterest
      mainFocus
      subindustryInterest
      timeframePreference
      enrollLikelihood
      programEnvironment
    }
    user {
      id
      nameFirst
      nameLast
      email
      phone
      phoneVerified
    }
  }
}
    ` as unknown as DocumentNode<GetViewerForHostedResultQuery, GetViewerForHostedResultQueryVariables>;
export const UpdateCustomerHostedResultDocument = gql`
    mutation updateCustomerHostedResult($data: CustomerUpdateInput!) {
  updateViewerCustomer(data: $data) {
    id
    user {
      id
      nameFirst
      nameLast
      email
      phone
      phoneVerified
    }
  }
}
    ` as unknown as DocumentNode<UpdateCustomerHostedResultMutation, UpdateCustomerHostedResultMutationVariables>;
export const UpdateCustomerDetailsHostedResultDocument = gql`
    mutation updateCustomerDetailsHostedResult($data: CustomerDetailsUpdateInput!) {
  updateViewerCustomerDetails(data: $data) {
    id
  }
}
    ` as unknown as DocumentNode<UpdateCustomerDetailsHostedResultMutation, UpdateCustomerDetailsHostedResultMutationVariables>;
export const CreateCustomerHostedResultDocument = gql`
    mutation createCustomerHostedResult($data: CustomerAndEnrollmentItemCreateInput!) {
  createOneCustomer(data: $data) {
    customer {
      id
      user {
        id
        email
        tokens {
          accessToken
          refreshToken
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<CreateCustomerHostedResultMutation, CreateCustomerHostedResultMutationVariables>;
export const RequestPhoneCodeHostedDocument = gql`
    mutation requestPhoneCodeHosted($phone: String!, $isMobile: Boolean!) {
  requestCodeViaPhone(phone: $phone, isMobile: $isMobile)
}
    ` as unknown as DocumentNode<RequestPhoneCodeHostedMutation, RequestPhoneCodeHostedMutationVariables>;
export const VerifyPhoneCodeHostedDocument = gql`
    mutation verifyPhoneCodeHosted($phone: String!, $code: String!) {
  verifyPhoneCode(phone: $phone, code: $code) {
    id
    phoneVerified
  }
}
    ` as unknown as DocumentNode<VerifyPhoneCodeHostedMutation, VerifyPhoneCodeHostedMutationVariables>;